module.exports = __webpack_public_path__ + "static/media/xp-banner6.1b2981c5.jpg";